import { Component,Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogClose } from '@angular/material/dialog';

import { ToastrService } from 'ngx-toastr';
import { DtoUserReportView } from '../../../models/userProfile.model';

@Component({
  selector: 'app-save-report-view',
  templateUrl: './save-report-view.component.html'
})
export class SaveReportViewComponent implements OnInit {
formGroup: FormGroup = new FormGroup({
    viewName: new FormControl('', [
      Validators.required,
      Validators.maxLength(200),
      Validators.pattern("^.*[a-zA-Z]+.*$ ?") //Should have atleast on alphabet
    ]),
    snapshotType: new FormControl('Snapshot',[
      Validators.required
    ])
  });

  constructor(
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<SaveReportViewComponent>,
   @Inject(MAT_DIALOG_DATA) public data: any,
    private toasterService: ToastrService){

  }

  reportViews: DtoUserReportView[] = []
  ngOnInit(): void {
    //this.toasterService.info(JSON.stringify(this.data));

  }

  
  processForm(){
    
    this.dialogRef.close(
      this.formGroup.value
    );
  }

}
